// Utility to ensure the element that triggered an overlay is visible on screen
export function scrollTriggerIntoView() {
  if (typeof document === 'undefined') return;
  try {
    const el = document.activeElement;
    if (!el || el === document.body || el === document.documentElement) return;
    // Use smooth scrolling to center the trigger so the overlay appears near it
    el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
  } catch (err) {
    // ignore any errors
    // eslint-disable-next-line no-console
    console.debug('scrollTriggerIntoView failed', err);
  }
}
